import { FC } from "react";
import { Share as ShareIcon } from "@mui/icons-material";
import styles from "./SourcePill.module.css";

interface ShareButtonProps {
  onClick: () => void;
}

export const ShareButton: FC<ShareButtonProps> = ({ onClick }) => {
  return (
    <>
      <div className={styles.tooltipButton}>
        <button className={styles.actionButton} onClick={onClick}>
          <div className={styles.actionIcon}>
            <ShareIcon fontSize="small" />
          </div>
          <span className={styles.actionLabel}>Share</span>
        </button>
      </div>
    </>
  );
};
